/* tslint:disable */
/* eslint-disable */
/**
 * Thynk Direct API
 * The API for managing reservation for [Thynk Direct](https://thynk.cloud/).
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// May contain unused imports in some cases
// @ts-ignore
import { LanguageSettingsPartnerRead } from './language-settings-partner-read';
// May contain unused imports in some cases
// @ts-ignore
import { PartnerRead } from './partner-read';
// May contain unused imports in some cases
// @ts-ignore
import { PartnerSettingsTranslationPartnerRead } from './partner-settings-translation-partner-read';
// May contain unused imports in some cases
// @ts-ignore
import { PartnerSettingsUserReadUserReadAdminReservationSourceTimersInner } from './partner-settings-user-read-user-read-admin-reservation-source-timers-inner';
// May contain unused imports in some cases
// @ts-ignore
import { WebformImageObjectPartnerRead } from './webform-image-object-partner-read';

/**
 *
 * @export
 * @interface PartnerSettingsPartnerRead
 */
export interface PartnerSettingsPartnerRead {
  /**
   *
   * @type {string}
   * @memberof PartnerSettingsPartnerRead
   */
  '@context'?: string | null;
  /**
   *
   * @type {string}
   * @memberof PartnerSettingsPartnerRead
   */
  '@id'?: string;
  /**
   *
   * @type {string}
   * @memberof PartnerSettingsPartnerRead
   */
  '@type'?: string;
  /**
   *
   * @type {string}
   * @memberof PartnerSettingsPartnerRead
   */
  id?: string;
  /**
   *
   * @type {PartnerRead}
   * @memberof PartnerSettingsPartnerRead
   */
  partner?: PartnerRead | null;
  /**
   * send mails if a big group tag is assigned to the reservation
   * @type {boolean}
   * @memberof PartnerSettingsPartnerRead
   * @deprecated
   */
  shouldReceiveLargePaxMail?: boolean;
  /**
   * send mails if the proposal expires (within x hours)
   * @type {boolean}
   * @memberof PartnerSettingsPartnerRead
   */
  shouldReceiveProposalExpiresMail?: boolean;
  /**
   * if autoPilot is true it starts the first transition automatically instead of a manual employee action
   * @type {boolean}
   * @memberof PartnerSettingsPartnerRead
   */
  autoPilot?: boolean;
  /**
   * if autoPilotLanguage is true it starts the first transition automatically instead of a manual employee action
   * @type {boolean}
   * @memberof PartnerSettingsPartnerRead
   */
  autoPilotLanguage?: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof PartnerSettingsPartnerRead
   */
  blockingFlags?: Array<PartnerSettingsPartnerReadBlockingFlagsEnum>;
  /**
   * The default payment method under threshold
   * @type {string}
   * @memberof PartnerSettingsPartnerRead
   */
  defaultPaymentMethodUnderThreshold?: PartnerSettingsPartnerReadDefaultPaymentMethodUnderThresholdEnum;
  /**
   * The default payment method above threshold
   * @type {string}
   * @memberof PartnerSettingsPartnerRead
   */
  defaultPaymentMethodAboveThreshold?: PartnerSettingsPartnerReadDefaultPaymentMethodAboveThresholdEnum;
  /**
   * database stores currency in cents so this is 1000 euro
   * @type {number}
   * @memberof PartnerSettingsPartnerRead
   */
  paymentMethodThreshold?: number;
  /**
   * mode how the threshold should apply
   * @type {string}
   * @memberof PartnerSettingsPartnerRead
   */
  costChangeThresholdMode?: PartnerSettingsPartnerReadCostChangeThresholdModeEnum;
  /**
   * Threshold to renew the invoice when revenue changed.
   * @type {number}
   * @memberof PartnerSettingsPartnerRead
   */
  costChangeThreshold?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof PartnerSettingsPartnerRead
   */
  expirationRules?: Array<string>;
  /**
   * The terms and conditions page for the partner. Should be a valid url.
   * @type {string}
   * @memberof PartnerSettingsPartnerRead
   */
  termsUrl?: string | null;
  /**
   *
   * @type {string}
   * @memberof PartnerSettingsPartnerRead
   */
  gdprFilePath?: string | null;
  /**
   *
   * @type {string}
   * @memberof PartnerSettingsPartnerRead
   */
  defaultEmplacement?: string | null;
  /**
   * The default emplacement for a reservation with big groups.
   * @type {string}
   * @memberof PartnerSettingsPartnerRead
   */
  bigGroupsDefaultEmplacement?: string | null;
  /**
   *
   * @type {Array<PartnerSettingsUserReadUserReadAdminReservationSourceTimersInner>}
   * @memberof PartnerSettingsPartnerRead
   */
  reservationSourceTimers?: Array<PartnerSettingsUserReadUserReadAdminReservationSourceTimersInner>;
  /**
   * If set to true, automated mails for a reservation will be delayed and not be sent before Monday morning.
   * @type {boolean}
   * @memberof PartnerSettingsPartnerRead
   */
  weekendMailDelay?: boolean;
  /**
   * This is the check-in time of a partner. This stores the time as \"12:00\".
   * @type {string}
   * @memberof PartnerSettingsPartnerRead
   */
  defaultCheckinTime?: string | null;
  /**
   * This is the check-out time of a partner. This stores the time as \"12:00\".
   * @type {string}
   * @memberof PartnerSettingsPartnerRead
   */
  defaultCheckoutTime?: string | null;
  /**
   * This is used to determine if a partner has the option of late checkout.
   * @type {boolean}
   * @memberof PartnerSettingsPartnerRead
   */
  lateCheckoutEnabled?: boolean;
  /**
   * This is used to determine if a partner has the option of breakfast.
   * @type {boolean}
   * @memberof PartnerSettingsPartnerRead
   */
  breakfastEnabled?: boolean;
  /**
   * 6-digit (or 3-digit) hex color code for the partner look and feel (without the leading hash)
   * @type {string}
   * @memberof PartnerSettingsPartnerRead
   */
  color?: string;
  /**
   * 6-digit (or 3-digit) alternative hex color code for the partner if it conflicts with the primary color (without the leading hash)
   * @type {string}
   * @memberof PartnerSettingsPartnerRead
   * @deprecated
   */
  secondaryColor?: string;
  /**
   * the font used on the webform
   * @type {string}
   * @memberof PartnerSettingsPartnerRead
   */
  webformFont?: PartnerSettingsPartnerReadWebformFontEnum;
  /**
   * should the containers on the webform have rounded corners
   * @type {boolean}
   * @memberof PartnerSettingsPartnerRead
   */
  webformRoundedBoxes?: boolean;
  /**
   * should the user be able to select their own preferred halls in the webform
   * @type {boolean}
   * @memberof PartnerSettingsPartnerRead
   */
  hallPreferenceEnabled?: boolean;
  /**
   *
   * @type {Array<PartnerSettingsTranslationPartnerRead>}
   * @memberof PartnerSettingsPartnerRead
   */
  translations?: Array<PartnerSettingsTranslationPartnerRead>;
  /**
   *
   * @type {Array<WebformImageObjectPartnerRead>}
   * @memberof PartnerSettingsPartnerRead
   */
  webformImages?: Array<WebformImageObjectPartnerRead>;
  /**
   * An analytics key to load
   * @type {string}
   * @memberof PartnerSettingsPartnerRead
   */
  analyticsKey?: string | null;
  /**
   *
   * @type {string}
   * @memberof PartnerSettingsPartnerRead
   */
  clientToken?: string | null;
  /**
   *
   * @type {string}
   * @memberof PartnerSettingsPartnerRead
   */
  accessToken?: string | null;
  /**
   *
   * @type {string}
   * @memberof PartnerSettingsPartnerRead
   */
  endpoint?: string | null;
  /**
   *
   * @type {string}
   * @memberof PartnerSettingsPartnerRead
   */
  website?: string | null;
  /**
   *
   * @type {string}
   * @memberof PartnerSettingsPartnerRead
   */
  currency?: PartnerSettingsPartnerReadCurrencyEnum;
  /**
   *
   * @type {Array<string>}
   * @memberof PartnerSettingsPartnerRead
   */
  subscribedNotifications?: Array<PartnerSettingsPartnerReadSubscribedNotificationsEnum>;
  /**
   *
   * @type {LanguageSettingsPartnerRead}
   * @memberof PartnerSettingsPartnerRead
   */
  languageSettings?: LanguageSettingsPartnerRead;
  /**
   *
   * @type {boolean}
   * @memberof PartnerSettingsPartnerRead
   */
  isCopilotEnabled?: boolean;
  /**
   * The external name reference for the partner, for instance used as subdomain for the web form.
   * @type {string}
   * @memberof PartnerSettingsPartnerRead
   */
  slug?: string | null;
}

export const PartnerSettingsPartnerReadBlockingFlagsEnum = {
  Ai: 'AI',
  Bricksandbasics: 'bricksandbasics',
  Broker: 'broker',
  Cancel: 'cancel',
  Language: 'language',
  Ota: 'ota',
  Pax: 'pax',
  MReady: 'm-ready',
  LongLeadTime: 'long-lead-time',
  ShortLeadTime: 'short-lead-time',
} as const;

export type PartnerSettingsPartnerReadBlockingFlagsEnum =
  (typeof PartnerSettingsPartnerReadBlockingFlagsEnum)[keyof typeof PartnerSettingsPartnerReadBlockingFlagsEnum];
export const PartnerSettingsPartnerReadDefaultPaymentMethodUnderThresholdEnum =
  {
    AtLocation: 'AT_LOCATION',
    CreditCard: 'CREDIT_CARD',
    Invoice: 'INVOICE',
    PrePayment: 'PRE_PAYMENT',
    Voucher: 'VOUCHER',
  } as const;

export type PartnerSettingsPartnerReadDefaultPaymentMethodUnderThresholdEnum =
  (typeof PartnerSettingsPartnerReadDefaultPaymentMethodUnderThresholdEnum)[keyof typeof PartnerSettingsPartnerReadDefaultPaymentMethodUnderThresholdEnum];
export const PartnerSettingsPartnerReadDefaultPaymentMethodAboveThresholdEnum =
  {
    AtLocation: 'AT_LOCATION',
    CreditCard: 'CREDIT_CARD',
    Invoice: 'INVOICE',
    PrePayment: 'PRE_PAYMENT',
    Voucher: 'VOUCHER',
  } as const;

export type PartnerSettingsPartnerReadDefaultPaymentMethodAboveThresholdEnum =
  (typeof PartnerSettingsPartnerReadDefaultPaymentMethodAboveThresholdEnum)[keyof typeof PartnerSettingsPartnerReadDefaultPaymentMethodAboveThresholdEnum];
export const PartnerSettingsPartnerReadCostChangeThresholdModeEnum = {
  Percentage: 'percentage',
  Absolute: 'absolute',
} as const;

export type PartnerSettingsPartnerReadCostChangeThresholdModeEnum =
  (typeof PartnerSettingsPartnerReadCostChangeThresholdModeEnum)[keyof typeof PartnerSettingsPartnerReadCostChangeThresholdModeEnum];
export const PartnerSettingsPartnerReadWebformFontEnum = {
  Replica: 'Replica',
  Verdana: 'Verdana',
  Arial: 'Arial',
  Georgia: 'Georgia',
  Times: 'Times',
  TimesNewRoman: 'Times New Roman',
  Courier: 'Courier',
  Tahoma: 'Tahoma',
  TrebuchetMs: 'Trebuchet MS',
} as const;

export type PartnerSettingsPartnerReadWebformFontEnum =
  (typeof PartnerSettingsPartnerReadWebformFontEnum)[keyof typeof PartnerSettingsPartnerReadWebformFontEnum];
export const PartnerSettingsPartnerReadCurrencyEnum = {
  Eur: 'EUR',
  Usd: 'USD',
  Chf: 'CHF',
  Gbp: 'GBP',
  Aed: 'AED',
  Bhd: 'BHD',
  Qar: 'QAR',
  Sar: 'SAR',
  Iqd: 'IQD',
  Jod: 'JOD',
  Mad: 'MAD',
  Try: 'TRY',
  Tzs: 'TZS',
  Zar: 'ZAR',
  Null: 'null',
} as const;

export type PartnerSettingsPartnerReadCurrencyEnum =
  (typeof PartnerSettingsPartnerReadCurrencyEnum)[keyof typeof PartnerSettingsPartnerReadCurrencyEnum];
export const PartnerSettingsPartnerReadSubscribedNotificationsEnum = {
  VenueInquiryConfirmationEmail: 'venue_inquiry_confirmation_email',
} as const;

export type PartnerSettingsPartnerReadSubscribedNotificationsEnum =
  (typeof PartnerSettingsPartnerReadSubscribedNotificationsEnum)[keyof typeof PartnerSettingsPartnerReadSubscribedNotificationsEnum];
